import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap"; // Aggiunto Alert

export default function ModalIntervalliPunteggio({
  show,
  onClose,
  onSave,
  punteggioMin,
  punteggioMax,
  intervalliPredefiniti = [],
  readonly = false,
}) {
  const [intervalli, setIntervalli] = useState([]);
  const [errore, setErrore] = useState("");
  const [warning, setWarning] = useState(""); // Stato per avvisi non bloccanti

   // Funzione helper per generare default (la estraiamo per pulizia)
   const generateDefaultIntervals = (pMin, pMax) => {
    const numeroDefaultIntervalli = Math.max(1, Math.min(3, pMax - pMin + 1));
    const rangeTotale = Math.max(0, pMax - pMin);
    const rangePerIntervallo = rangeTotale > 0 ? Math.max(1, Math.floor((rangeTotale + 1) / numeroDefaultIntervalli)) : 1;

    let defaults = Array.from({ length: numeroDefaultIntervalli }, (_, i) => {
        const start = pMin + i * rangePerIntervallo;
        const end = (i === numeroDefaultIntervalli - 1)
                   ? pMax
                   : Math.min(pMax, start + rangePerIntervallo - 1);
         const inizioEffettivo = Math.min(start, end);
        return { intPunId: null, intPunMin: inizioEffettivo, intPunMax: end, intPunDescrizione: "" };
    });

    // Correzioni (come prima)
    for (let i = 0; i < defaults.length -1; i++) {
         if (defaults[i].intPunMax + 1 !== defaults[i+1].intPunMin && defaults[i].intPunMax < pMax) { // Aggiunto controllo < pMax
             defaults[i+1].intPunMin = defaults[i].intPunMax + 1;
         }
         if (defaults[i+1].intPunMax < defaults[i+1].intPunMin) {
            defaults[i+1].intPunMax = defaults[i+1].intPunMin;
         }
     }
     if(defaults.length > 0) {
         defaults[defaults.length - 1].intPunMax = pMax;
         if (defaults[defaults.length - 1].intPunMin > pMax) {
             defaults[defaults.length - 1].intPunMin = pMax;
         }
     }
     if (pMin === pMax && defaults.length > 0) {
          defaults = [{ intPunId: null, intPunMin: pMin, intPunMax: pMax, intPunDescrizione: "" }];
     } else if (pMin === pMax && defaults.length === 0) { // Caso pMin=pMax e nessun default generato
          defaults = [{ intPunId: null, intPunMin: pMin, intPunMax: pMax, intPunDescrizione: "" }];
     }
     return defaults;
};

// useEffect per INIZIALIZZARE/RESETTARE lo stato interno quando il modal viene mostrato
useEffect(() => {
  if (show) {
     

      let intervalliIniziali = [];

      // Logga la condizione PRIMA di eseguirla
      const hasPredefiniti = intervalliPredefiniti && Array.isArray(intervalliPredefiniti) && intervalliPredefiniti.length > 0;

      if (hasPredefiniti) {
        const primoMin = intervalliPredefiniti[0].intPunMin;
        const ultimoMax = intervalliPredefiniti[intervalliPredefiniti.length - 1].intPunMax;
    
        if (primoMin !== punteggioMin || ultimoMax !== punteggioMax) {
            const adattati = adattaIntervalliProporzionalmente(intervalliPredefiniti, primoMin, ultimoMax, punteggioMin, punteggioMax);
            intervalliIniziali = adattati.map(i => ({
                ...i,
                intPunDescrizione: i.intPunDescrizione || "" // mantieni etichetta
            }));
            setWarning(`⚠️ Il range di punteggio è cambiato (${punteggioMin}-${punteggioMax}). Gli intervalli sono stati adattati mantenendo le etichette.`);
        } else {
            intervalliIniziali = intervalliPredefiniti.map(i => ({
                ...i,
                intPunMin: parseInt(i.intPunMin, 10),
                intPunMax: parseInt(i.intPunMax, 10),
                intPunDescrizione: i.intPunDescrizione || ""
            }));
            setWarning("");
        }
    }
    
    
    

      setIntervalli(intervalliIniziali);
      setErrore("");
     // setWarning("");
  } else {
       // Optional: Log when modal is hidden
       // console.log("Modal useEffect: Modal hidden, skipping state update.");
  }
  

}, [show, punteggioMin, punteggioMax, readonly, intervalliPredefiniti]); // Dipendenze corrette
const adattaIntervalliProporzionalmente = (intervalli, oldMin, oldMax, newMin, newMax) => {
  const rangeVecchio = oldMax - oldMin;
  const rangeNuovo = newMax - newMin;

  return intervalli.map(i => {
      const nuovoMin = Math.round(((i.intPunMin - oldMin) / rangeVecchio) * rangeNuovo + newMin);
      const nuovoMax = Math.round(((i.intPunMax - oldMin) / rangeVecchio) * rangeNuovo + newMin);
      return {
          ...i,
          intPunMin: Math.min(nuovoMin, nuovoMax),
          intPunMax: Math.max(nuovoMin, nuovoMax)
      };
  });
};
/*
  useEffect(() => {
    if (!show) {
        setIntervalli([]); // Pulisci stato all'uscita
        setErrore("");
        setWarning("");
        return;
    };

    let intervalliIniziali = [];

    if (intervalliPredefiniti && intervalliPredefiniti.length > 0) {
        intervalliIniziali = intervalliPredefiniti.map(ip => ({
            intPunId: ip.intPunId,
            intPunMin: parseInt(ip.intPunMin, 10), // Assicura siano numeri
            intPunMax: parseInt(ip.intPunMax, 10),
            intPunDescrizione: ip.intPunDescrizione
        })).sort((a, b) => a.intPunMin - b.intPunMin); // Ordina sempre
    } else if (!readonly) {
        // Genera default solo se non readonly e non ci sono predefiniti
        const numeroDefaultIntervalli = Math.max(1, Math.min(3, punteggioMax - punteggioMin + 1)); // Da 1 a 3 default
        const rangeTotale = Math.max(0, punteggioMax - punteggioMin);
        const rangePerIntervallo = rangeTotale > 0 ? Math.max(1, Math.floor((rangeTotale + 1) / numeroDefaultIntervalli)) : 1;

        intervalliIniziali = Array.from({ length: numeroDefaultIntervalli }, (_, i) => {
            const start = punteggioMin + i * rangePerIntervallo;
            const end = (i === numeroDefaultIntervalli - 1)
                       ? punteggioMax
                       : Math.min(punteggioMax, start + rangePerIntervallo - 1);
             const inizioEffettivo = Math.min(start, end);

            return {
                intPunId: null,
                intPunMin: inizioEffettivo,
                intPunMax: end,
                intPunDescrizione: ""
            };
        });

         // Correzione finale per assicurare copertura completa e non sovrapposizione
         for (let i = 0; i < intervalliIniziali.length -1; i++) {
             if (intervalliIniziali[i].intPunMax + 1 !== intervalliIniziali[i+1].intPunMin) {
                 intervalliIniziali[i+1].intPunMin = intervalliIniziali[i].intPunMax + 1;
             }
             if (intervalliIniziali[i+1].intPunMax < intervalliIniziali[i+1].intPunMin) {
                intervalliIniziali[i+1].intPunMax = intervalliIniziali[i+1].intPunMin;
             }
         }
         if(intervalliIniziali.length > 0) {
             intervalliIniziali[intervalliIniziali.length - 1].intPunMax = punteggioMax;
             if (intervalliIniziali[intervalliIniziali.length - 1].intPunMin > punteggioMax) {
                 intervalliIniziali[intervalliIniziali.length - 1].intPunMin = punteggioMax;
             }
         }
         if (punteggioMin === punteggioMax && intervalliIniziali.length > 0) {
             intervalliIniziali = [{ intPunId: null, intPunMin: punteggioMin, intPunMax: punteggioMax, intPunDescrizione: "" }];
         }
    }

    setIntervalli(intervalliIniziali);
    setErrore("");
    setWarning("");

  }, [show, punteggioMin, punteggioMax, readonly, intervalliPredefiniti]);*/


  // --- Funzione aggiornata per gestire modifiche e collegamenti ---
  const aggiornaCampo = (index, chiaveBackend, valore) => {
    setErrore(""); // Pulisce errori precedenti ad ogni tentativo di modifica
    setWarning("");

    const copia = intervalli.map(i => ({...i})); // Copia profonda per evitare side effects
    const intervalloCorrente = copia[index];
    let valoreNumerico = NaN;

    if (chiaveBackend !== "intPunDescrizione") {
        valoreNumerico = parseInt(valore, 10);
        if (isNaN(valoreNumerico)) {
            setErrore(`Intervallo ${index + 1}: Inserire un valore numerico valido per ${chiaveBackend === 'intPunMin' ? 'Inizio' : 'Fine'}.`);
            return; // Blocca se non è un numero
        }
    }

    // --- Logica di aggiornamento e validazione ---
    if (chiaveBackend === "intPunDescrizione") {
        intervalloCorrente.intPunDescrizione = valore;
    }
    else if (chiaveBackend === "intPunMax") {
        // Modificabile solo se NON è l'ultimo intervallo
        if (index < copia.length - 1) {
            const intervalloSuccessivo = copia[index + 1];

            // Validazione 1: Nuovo Max >= Min corrente
            if (valoreNumerico < intervalloCorrente.intPunMin) {
                setErrore(`Intervallo ${index + 1}: Il valore di Fine (${valoreNumerico}) non può essere minore dell'Inizio (${intervalloCorrente.intPunMin}).`);
                return;
            }

            // Validazione 2: Nuovo Max deve essere <= Max originale del successivo - 1
            // (perché il successivo Min diventerà valoreNumerico + 1)
            const maxPossibilePerQuesto = intervalloSuccessivo.intPunMax -1;
             if (valoreNumerico > maxPossibilePerQuesto) {
                setErrore(`Intervallo ${index + 1}: Il valore di Fine (${valoreNumerico}) non può superare ${maxPossibilePerQuesto} per permettere un intervallo successivo valido.`);
                return;
            }


            // Aggiorna corrente e successivo
            intervalloCorrente.intPunMax = valoreNumerico;
            intervalloSuccessivo.intPunMin = valoreNumerico + 1;

        } else {
             // Se è l'ultimo, non dovrebbe essere modificabile (campo disabilitato)
             console.warn("Tentativo di modifica del campo Fine dell'ultimo intervallo (ignorato).");
             return;
        }
    }
    else if (chiaveBackend === "intPunMin") {
        // Modificabile solo se NON è il primo intervallo
        if (index > 0) {
            const intervalloPrecedente = copia[index - 1];

             // Validazione 1: Nuovo Min <= Max corrente
            if (valoreNumerico > intervalloCorrente.intPunMax) {
                setErrore(`Intervallo ${index + 1}: Il valore di Inizio (${valoreNumerico}) non può essere maggiore della Fine (${intervalloCorrente.intPunMax}).`);
                return;
            }

             // Validazione 2: Nuovo Min >= Min originale del precedente + 1
             // (perché il precedente Max diventerà valoreNumerico - 1)
             const minPossibilePerQuesto = intervalloPrecedente.intPunMin + 1;
             if (valoreNumerico < minPossibilePerQuesto) {
                 setErrore(`Intervallo ${index + 1}: Il valore di Inizio (${valoreNumerico}) non può essere inferiore a ${minPossibilePerQuesto} per permettere un intervallo precedente valido.`);
                 return;
             }

            // Aggiorna corrente e precedente
            intervalloCorrente.intPunMin = valoreNumerico;
            intervalloPrecedente.intPunMax = valoreNumerico - 1;

        } else {
            // Se è il primo, non dovrebbe essere modificabile (campo disabilitato)
            console.warn("Tentativo di modifica del campo Inizio del primo intervallo (ignorato).");
            return;
        }
    }

    // Se tutto ok, aggiorna lo stato
    setIntervalli(copia);
  };

  // --- Funzione Aggiungi Intervallo Corretta ---
  const aggiungiIntervallo = () => {
    setErrore("");
    setWarning("");

    if (intervalli.length === 0) {
         // Caso speciale: se non ci sono intervalli, ne crea uno che copre tutto
         setIntervalli([{
             intPunId: null,
             intPunMin: punteggioMin,
             intPunMax: punteggioMax,
             intPunDescrizione: ""
         }]);
         return;
    }

    const ultimoIntervallo = intervalli[intervalli.length - 1];

    // Non si può aggiungere se l'ultimo intervallo ha già inizio = fine
    if (ultimoIntervallo.intPunMin === ultimoIntervallo.intPunMax) {
        setErrore("Non è possibile dividere ulteriormente l'ultimo intervallo.");
        return;
    }

    // Calcola dove dividere l'ultimo intervallo (es. a metà, arrotondato)
    // Il nuovo intervallo inizierà da 'nuovoInizio'
    // Il vecchio ultimo intervallo finirà a 'nuovoInizio - 1'
    const puntoMedio = Math.floor((ultimoIntervallo.intPunMin + ultimoIntervallo.intPunMax) / 2);
    let nuovoInizio = puntoMedio + 1;

    // Assicurati che nuovoInizio sia valido (almeno min + 1 e <= max)
    nuovoInizio = Math.max(ultimoIntervallo.intPunMin + 1, nuovoInizio);
    nuovoInizio = Math.min(punteggioMax, nuovoInizio); // Non può superare il max totale

    const penultimoFine = nuovoInizio - 1;

     // Ulteriore controllo: il penultimoFine deve essere >= del suo inizio
     if (penultimoFine < ultimoIntervallo.intPunMin) {
         console.error("Errore logico in aggiungiIntervallo, divisione non possibile.");
         setErrore("Impossibile aggiungere l'intervallo a causa di un errore di calcolo.");
         return;
     }


    const copia = intervalli.map(i => ({...i})); // Copia profonda

    // Modifica il (precedente) ultimo intervallo
    copia[copia.length - 1].intPunMax = penultimoFine;

    // Aggiunge il nuovo ultimo intervallo
    copia.push({
      intPunId: null,
      intPunMin: nuovoInizio,
      intPunMax: punteggioMax, // Il nuovo ultimo va sempre fino a punteggioMax
      intPunDescrizione: ""
    });

    setIntervalli(copia);
    setWarning("Nuovo intervallo aggiunto. Controlla e compila l'etichetta.");
  };

  // --- Funzione Rimuovi Intervallo Corretta ---
  const rimuoviIntervallo = (index) => {
    setErrore("");
    setWarning("");

    if (intervalli.length <= 1) {
        setErrore("È necessario mantenere almeno un intervallo.");
        return;
    }

    const copia = intervalli.map(i => ({...i})); // Copia profonda
    const rimosso = copia.splice(index, 1)[0]; // Rimuove e ottiene l'elemento rimosso

    // Aggiusta gli intervalli adiacenti per "riempire il buco"
    if (copia.length > 0) {
        if (index === 0) {
            // Rimosso il primo: il nuovo primo (ora a index 0) deve iniziare da punteggioMin
            copia[0].intPunMin = punteggioMin;
        } else if (index >= copia.length) {
             // Rimosso l'ultimo: il nuovo ultimo (ora a index-1) deve finire a punteggioMax
             copia[copia.length - 1].intPunMax = punteggioMax;
        } else {
            // Rimosso in mezzo: l'intervallo precedente (a index-1)
            // deve ora estendersi fino alla fine dell'intervallo successivo (a index) - 1
            // Cioè, il Max del precedente diventa il Min del successivo - 1
             copia[index - 1].intPunMax = copia[index].intPunMin - 1;
             // Validazione aggiuntiva: assicurati che il Max del precedente non sia < del suo Min
             if (copia[index - 1].intPunMax < copia[index - 1].intPunMin) {
                 // Questo caso è problematico, potrebbe richiedere intervento manuale
                 // Per ora, forziamo il max = min per evitare incoerenza
                 copia[index - 1].intPunMax = copia[index - 1].intPunMin;
                 setWarning("Attenzione: la rimozione ha creato un intervallo precedente di lunghezza zero. Verifica i valori.");
             }
        }
    }

    setIntervalli(copia);
  };

  // --- Validazione Finale ---
  const validaEConferma = () => {
    setErrore(""); // Pulisce errori precedenti
    setWarning("");

    if (!intervalli || intervalli.length === 0) {
        setErrore("Nessun intervallo definito.");
        return;
    }

    for (let i = 0; i < intervalli.length; i++) {
      const { intPunMin, intPunMax, intPunDescrizione } = intervalli[i];

      if (isNaN(intPunMin) || isNaN(intPunMax) || intPunMin === null || intPunMax === null || !intPunDescrizione || !intPunDescrizione.trim()) {
        setErrore(`Intervallo ${i + 1}: Tutti i campi (Inizio, Fine, Etichetta) devono essere compilati.`);
        return;
      }

      if (intPunMax < intPunMin) {
        setErrore(`Intervallo ${i + 1}: Il valore di Fine (${intPunMax}) non può essere minore dell'Inizio (${intPunMin}).`);
        return;
      }

      // Controlla sovrapposizioni/buchi
      if (i > 0 && intPunMin !== intervalli[i - 1].intPunMax + 1) {
        setErrore(`Intervallo ${i + 1}: Gli intervalli non sono consecutivi. C'è un buco o una sovrapposizione prima di questo intervallo (trovato ${intPunMin}, atteso ${intervalli[i - 1].intPunMax + 1}).`);
        return;
      }
    }

    // Controlla copertura totale
    const primo = intervalli[0];
    const ultimo = intervalli[intervalli.length - 1];

    if (primo.intPunMin !== punteggioMin) {
       setErrore(`Il primo intervallo deve iniziare dal punteggio minimo (${punteggioMin}), invece inizia da ${primo.intPunMin}. Correggi i valori.`);
       return;
    }
    if (ultimo.intPunMax !== punteggioMax) {
       setErrore(`L'ultimo intervallo deve terminare con il punteggio massimo (${punteggioMax}), invece termina con ${ultimo.intPunMax}. Correggi i valori.`);
       return;
    }

    // Se tutto ok
    onSave(intervalli);
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{readonly ? "Intervalli punteggio" : "Definizione intervalli punteggio"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!readonly && (
            <p>
                Definisci le etichette per i diversi intervalli di punteggio.
                Il punteggio totale va da <strong>{punteggioMin}</strong> a <strong>{punteggioMax}</strong>.
                Puoi modificare i limiti intermedi; i valori adiacenti si adatteranno automaticamente.
            </p>
        )}
         {readonly && intervalli.length === 0 && (
             <Alert variant="info">Nessun intervallo di punteggio definito per questo sondaggio.</Alert>
         )}

        {intervalli.map((intervallo, idx) => (
          <Row key={intervallo.intPunId || `new-${idx}`} className="mb-3 align-items-center">
            {/* --- Colonna Inizio --- */}
            <Col md={2}>
              <Form.Label htmlFor={`intPunMin-${idx}`}>Inizio</Form.Label>
              <Form.Control
                  id={`intPunMin-${idx}`}
                  type="number"
                  value={isNaN(intervallo.intPunMin) ? '' : intervallo.intPunMin}
                  onChange={(e) => aggiornaCampo(idx, "intPunMin", e.target.value)}
                  // Disabilitato e readonly solo per il primo
                  disabled={readonly || idx === 0}
                  readOnly={readonly || idx === 0}
                  isInvalid={!!errore && errore.includes(`Intervallo ${idx + 1}`)}
              />
            </Col>

            {/* --- Colonna Fine --- */}
            <Col md={2}>
              <Form.Label htmlFor={`intPunMax-${idx}`}>Fine</Form.Label>
              <Form.Control
                  id={`intPunMax-${idx}`}
                  type="number"
                  value={isNaN(intervallo.intPunMax) ? '' : intervallo.intPunMax}
                  onChange={(e) => aggiornaCampo(idx, "intPunMax", e.target.value)}
                   // Disabilitato e readonly solo per l'ultimo
                  disabled={readonly || idx === intervalli.length - 1}
                  readOnly={readonly || idx === intervalli.length - 1}
                  isInvalid={!!errore && errore.includes(`Intervallo ${idx + 1}`)}
              />
            </Col>

            {/* --- Colonna Etichetta --- */}
            <Col md={readonly ? 8 : 6}>
              <Form.Label htmlFor={`intPunDesc-${idx}`}>Etichetta</Form.Label>
              <Form.Control
                  id={`intPunDesc-${idx}`}
                  type="text"
                  value={intervallo.intPunDescrizione}
                  onChange={(e) => aggiornaCampo(idx, "intPunDescrizione", e.target.value)}
                  placeholder="Es. Basso, Medio, Alto"
                  required
                  readOnly={readonly}
                  isInvalid={!!errore && errore.includes(`Intervallo ${idx + 1}`) && (!intervallo.intPunDescrizione || !intervallo.intPunDescrizione.trim())}
              />
            </Col>

            {/* --- Colonna Rimuovi --- */}
            {!readonly && (
              <Col md={2} className="text-end align-self-end"> {/* Allinea in basso */}
                <Button
                    variant="outline-danger"
                    onClick={() => rimuoviIntervallo(idx)}
                    title="Rimuovi questo intervallo"
                    disabled={intervalli.length <= 1} // Disabilita se è l'ultimo rimasto
                >
                  × Rimuovi
                </Button>
              </Col>
            )}
          </Row>
        ))}

        {/* --- Bottone Aggiungi --- */}
        {!readonly && (
          <div className="d-flex justify-content-end mt-3">
            <Button
                onClick={aggiungiIntervallo}
                // Disabilitato se l'ultimo intervallo ha già inizio = fine (non si può dividere)
                disabled={intervalli.length > 0 && intervalli[intervalli.length - 1]?.intPunMin === intervalli[intervalli.length - 1]?.intPunMax}
                variant="outline-primary" // Nuovo stile: sfondo bianco, bordo e testo blu primario

            >
              + Aggiungi intervallo
            </Button>
          </div>
        )}

        {/* --- Messaggi Errore/Warning --- */}
        {errore && <Alert variant="danger" className="mt-3 text-center">⚠️ {errore}</Alert>}
        {warning && !errore && <Alert variant="warning" className="mt-3 text-center">{warning}</Alert>}

      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {readonly ? "Chiudi" : "Annulla"}
        </Button>
        {!readonly && (
          <Button variant="primary" onClick={validaEConferma} disabled={!!errore}> {/* Disabilita conferma se c'è errore */}
            Conferma intervalli
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}